export default "<svg>\n\t\t<path d=\"M12.5,3.8v3.8C6.9,7.5,2.5,8.8,0,15c3.8-3.1,7.5-3.8,12.5-2.5v3.8L20,10L12.5,3.8z\"/>\n</svg>\n";